import { Content } from '@tiptap/core'

import { EditorText } from '../../EditorText'
import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type LikeProps = BaseNotificationItemProps & {
  userName: string
  message: string
  type: 'like'
}

export function Like({ userName, message, ...props }: LikeProps) {
  return (
    <NotificationItem
      {...props}
      title={`${userName} liked your comment 👍🏻`}
      descriptionAddon={
        <div className='flex text-left text-sm text-gray-500'>
          <p className='flex items-baseline'>
            <b className='min-w-fit'>You</b>
            <p className='mr-1 ml-1'>wrote:</p>
            <EditorText initialData={JSON.parse(message) as Content} editable={false} truncateText hasQuote />
          </p>
        </div>
      }
    />
  )
}
